// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Positions_componentWrapper__-8y25"};